export function parseAmount(value: string): number | null {
  const cleaned = value.replace(/,/g, '').trim();
  if (!cleaned) return null;
  const parsed = Number(cleaned);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : null;
}

export function isSignedAmountInput(value: string): boolean {
  const cleaned = value.replace(/,/g, '').trim();
  if (cleaned === '' || cleaned === '-') return true;
  return /^-?(\d+\.?\d*|\.\d*)$/.test(cleaned);
}

export function parseSignedAmount(value: string): number | null {
  const cleaned = value.replace(/,/g, '').trim();
  if (!cleaned || cleaned === '-') return null;
  const parsed = Number(cleaned);
  return Number.isFinite(parsed) ? parsed : null;
}

export function parseDay(value: string): number | null {
  if (!value.trim()) return null;
  const parsed = Number(value);
  if (!Number.isInteger(parsed) || parsed < 1 || parsed > 28) return null;
  return parsed;
}

export function parseYears(value: string): number | null {
  if (!value.trim()) return null;
  const parsed = Number(value);
  if (!Number.isInteger(parsed) || parsed < 0 || parsed > 30) return null;
  return parsed;
}
